module.exports = __webpack_public_path__ + "static/media/ic-close-icon.521cdee0.svg";